var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecoration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241.354,
    height: 79.317,
    viewBox: "0 0 241.354 79.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1471",
    "data-name": "Group 1471",
    transform: "translate(-1159.583 -513.865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2935",
    "data-name": "Path 2935",
    d: "M1382.433,530.405a26.181,26.181,0,0,1,4.664-2.273c3.613-1.247,4.73-1.063,8.152.768l3.269,1.75a8.621,8.621,0,0,1-.362,8.012,12.474,12.474,0,0,1-3.983,4.475c-5.8,3.948-13.583,3.481-19.927,1.27-11.983-4.178-22.086-13.063-33.716-18.216-15.881-7.036-44.981-14.567-53.515,7.173-7.24,18.446,9.238,34.674,26.83,36.189,5.2.448,16.2-1.883,12.45-9.595-3.618-7.437-15.538-9.385-22.731-8.412-9.854,1.332-18.311,7.853-23.721,15.972-5.2,7.8-8.768,19.069.158,25.569.46.335,1.065-.446.61-.8-10.964-8.5-.577-24.18,7.032-31.175,8.277-7.61,20.727-11.094,31.178-5.725,1.2.617,3.831,2.011,4.258,2.859q-.442,2.236-.886,4.473,1.223,4.965-2.46,4.673c-2.488.627-5.683.084-8.151-.316a32.323,32.323,0,0,1-13.77-5.6c-8.689-6.276-13.408-18.772-7.842-28.7,11.937-21.292,45.671-6.591,61.131,1.888,12.534,6.875,29.331,19.832,43.854,9.806,4.337-2.994,7.848-9.485,4.883-14.6-3.99-6.877-12.758-3.474-17.75-.058a.341.341,0,0,0,.345.588Z",
    fill: "#b58156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2936",
    "data-name": "Path 2936",
    d: "M1294.926,548.109c-2.377-7.92,3.438-14.672,11.032-16.109,7.314-1.383,14.446,1.68,20.92,4.666,9.313,4.294,18.509,8.211,28.537,10.582,6.624,1.565,17.478,5.007,23.377-.053,3.834-3.287,3.846-9.2,1.322-13.3-9.315-15.148-32.454.388-44.386,2.821a74.766,74.766,0,0,1-31.909-.536c-5.217-1.225-37.142-12.11-24.533-21.361.509-.373.023-1.231-.5-.858-11.061,7.85,6.433,17.488,12.463,20.079a76.207,76.207,0,0,0,43.1,4.912c8.219-1.451,15.437-4.967,23.262-7.623,4.575-1.552,10.3-2.8,14.985-.884,6.97,2.853,11.381,14.153,1.469,16.657-8.678,2.192-20.2-1.927-28.5-4.7-8.913-2.974-17.011-8.008-25.955-10.8-6.691-2.084-14.957-2.446-20.741,2.164a12.949,12.949,0,0,0-4.473,14.48c.116.332.637.2.534-.143Z",
    fill: "#b58156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1465",
    "data-name": "Group 1465"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2937",
    "data-name": "Path 2937",
    d: "M1313.382,558.05a.074.074,0,0,0,0-.147.074.074,0,0,0,0,.147Z",
    fill: "#b58156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1466",
    "data-name": "Group 1466"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2938",
    "data-name": "Path 2938",
    d: "M1312.585,558.849q-4.82.235-3.757-3.568a7.148,7.148,0,0,1,1.132-4.964,11.741,11.741,0,0,1,5.883-4.972c4.488-1.926,9.435-1.432,13.991.025,7.171,2.293,13.169,7.21,20.076,10.1,8.74,3.657,20.146,3.871,27.026-3.516.387-.416-.191-.955-.616-.609-6.486,5.277-14.5,6.378-22.437,3.942-7.056-2.166-12.926-6.934-19.584-9.963-8.436-3.837-21.3-5.175-25.922,5-1.8,3.969-.188,16.223,6.7,12.143,4.275-2.53-.487-7.613-2.975-3.986-.195.283.251.625.479.366Z",
    fill: "#b58156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1467",
    "data-name": "Group 1467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M1178.337,529.816c-4.62-3.161-11.1-6.115-16.068-1.864-3.928,3.357-3.1,9.149-.389,13.017,9.467,13.517,28.859,4.694,39.535-1.687,16.235-9.7,42.218-24.244,61.187-14,10.711,5.782,12.821,19.183,6.726,29.177-5.181,8.5-15.672,12.865-25.317,13.074-1.031.022-3.995.335-4.888-.335l-1.77-8.952,2.715-1.991a23.767,23.767,0,0,1,9.745-3.225,27.637,27.637,0,0,1,17.48,3.938c9.636,5.813,25.48,25.275,12.623,35.247-.5.39-.022,1.263.513.874,16.179-11.78-4.711-35.2-17.3-39.943-8.249-3.108-18.227-2.423-25.387,3-5.944,4.5-5.005,11.4,2.572,13.165,17.441,4.07,36.549-12.208,34.569-29.91-.967-8.636-6.515-15.264-14.506-18.462-10.747-4.3-22.971-1.416-33.422,2.4-12.535,4.571-22.921,12.289-34.642,18.355-6.616,3.425-14.334,5.847-21.742,3.513-5.484-1.727-9.7-5.942-8.977-11.932,1.122-9.289,11.381-5.777,16.4-2.857.384.223.7-.345.341-.59Z",
    fill: "#b58156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2940",
    "data-name": "Path 2940",
    d: "M1263.676,548.254c4.191-12.031-8.905-19.076-19.188-17.948-7.948.873-14.964,5.189-22.153,8.329a118.475,118.475,0,0,1-28.657,8.4c-5.8.926-15.61,1.366-15.533-7.05.066-7.082,7.095-10.352,13.243-10.435,8.947-.12,17.328,5.607,25.776,7.919a76.075,76.075,0,0,0,44.962-1.589c6.2-2.187,29.918-12.869,17.157-21.924-.525-.373-1.007.488-.5.861,12.606,9.249-19.363,20.137-24.532,21.358a74.651,74.651,0,0,1-31.908.539c-11.9-2.425-35.077-17.987-44.395-2.817-2.522,4.107-2.508,10.012,1.332,13.3,5.873,5.03,16.809,1.6,23.366.05,10.02-2.369,19.252-6.269,28.547-10.587,5.977-2.776,12.436-5.55,19.2-4.9,8.272.8,15.345,7.7,12.751,16.342-.1.344.417.478.533.146Z",
    fill: "#b58156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1469",
    "data-name": "Group 1469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M1244.685,558.05a.074.074,0,0,0,0-.147.074.074,0,0,0,0,.147Z",
    fill: "#b58156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M1245.962,558.481c-2.3-3.357-6.9.79-3.574,3.637,2.253,1.928,5.2.559,6.768-1.5,2.233-2.93,1.979-7.108.533-10.293-4.427-9.743-16.706-8.971-24.981-5.4-7.043,3.037-13.157,8.028-20.519,10.367-7.9,2.507-16,1.3-22.444-3.944a.433.433,0,0,0-.609.615c6.891,7.4,18.27,7.145,27.023,3.512,6.927-2.876,12.909-7.736,20.071-10.1a21.175,21.175,0,0,1,12.452-.665,12.464,12.464,0,0,1,7.429,5.615q.552,1.4,1.1,2.793,2.1,5.587-3.728,5.737c.225.256.672-.085.476-.37Z",
    fill: "#b58156"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoration);
export default __webpack_public_path__ + "static/media/decoration.de82b498ed80a1ffde44976e176322b8.svg";
export { ForwardRef as ReactComponent };